var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.797 4.952A2.364 2.364 0 015 4.625h14c.439 0 .85.119 1.203.327l-6.438 7.152a2.375 2.375 0 01-3.53 0L3.797 4.952zm-.874.896c-.19.341-.298.734-.298 1.152v10c0 .438.119.849.326 1.201a.63.63 0 01.072-.105l5.293-6.255-5.393-5.993zM5 19.375c-.438 0-.849-.119-1.201-.326a.622.622 0 00.178-.145l5.183-6.125.146.162a3.625 3.625 0 005.388 0l.146-.162 5.183 6.125c.051.06.112.11.178.145a2.363 2.363 0 01-1.201.326H5zm16.05-1.174c.206-.352.325-.763.325-1.201V7c0-.418-.108-.81-.297-1.152l-5.394 5.993 5.293 6.255a.627.627 0 01.072.105zM5 3.375A3.625 3.625 0 001.375 7v10A3.625 3.625 0 005 20.625h14A3.625 3.625 0 0022.625 17V7A3.625 3.625 0 0019 3.375H5z",
    fill: "currentColor"
  })));
}
export default SvgEmail;